export const _setComments = (state, action) => {
  state.comment = action.payload;
};
